import { useEffect } from "react";
import {
  formatNumberWithCommas,
  parseNumericValue,
} from "../utils/format-number";

const PurchaseOrderTable = ({
  orderProducts,
  data,
  setOrderProducts,
  units = [],
  overallTotal,
  setOverallTotal,
}) => {
    const products = orderProducts ?? data ?? [];
    const updateProducts =
      typeof setOrderProducts === "function" ? setOrderProducts : () => {};

    const getOverallTotal = () => {
        let total = 0
        products.forEach(function (item) {
            total += parseNumericValue(item.quantity) * parseNumericValue(item.orderPrice ?? item.price)
        });
        total = parseFloat((total).toFixed(2))
        setOverallTotal(total)
    }

    useEffect(() => {
        getOverallTotal()
    }, [products])

    return (
        <div className='table-container'>
            <table className='x-table product-list-table purchase-order-table'>
                <thead>
                    <tr>
                        <th>Product Name</th>
                        <th>Unit</th>
                        <th>Quantity</th>
                        <th>Price</th>
                        <th>Total</th>
                    </tr>
                </thead>
                <tbody>
                    {products.map((item) => (
                        <tr key={item.product_id}>
                            <td>{item.product_name}</td>
                            <td>
                                <select
                                    id={`unit-${item.product_id}`}
                                    type='text'
                                    onChange={(e) => {
                                        const orderUnit = e.target.value
                                        updateProducts(prevData => {
                                            return prevData.map(product => (product.product_id === item.product_id ? { ...product, orderUnit } : product));
                                        });
                                    }}
                                    value={item.orderUnit ?? item.unit_id ?? ""}
                                    required
                                    className="border border-solid border-neutral-300 rounded"
                                    style={{ width: "100%" }}
                                >
                                    <option value='' disabled>Select</option>
                                    {
                                        units.map((item, index) => (
                                            <option key={index} value={item.unit_id}>{item.unit_name}</option>
                                        ))
                                    }
                                </select>
                            </td>
                            <td>
                                <input
                                    id={`qty-${item.product_id}`}
                                    className="border border-solid border-neutral-300 rounded"
                                    style={{ width: "100%" }}
                                    min='1'
                                    value={item.quantity}
                                    type="number"
                                    onChange={(e) => {
                                        const quantity = e.target.value;
                                        updateProducts(prevData => {
                                            return prevData.map(product => (product.product_id === item.product_id ? { ...product, quantity } : product));
                                        });
                                        getOverallTotal();
                                    }}
                                />
                            </td>
                            <td>
                                <input
                                    id={`price-${item.product_id}`}
                                    className="border border-solid border-neutral-300 rounded"
                                    style={{ width: "100%" }}
                                    min='1'
                                    value={formatNumberWithCommas(item.orderPrice ?? item.price)}
                                    type="text"
                                    inputMode="decimal"
                                    onChange={(e) => {
                                        const orderPrice = e.target.value.replace(/,/g, "");
                                        updateProducts(prevData => {
                                            return prevData.map(product => (product.product_id === item.product_id ? { ...product, orderPrice } : product));
                                        });
                                        getOverallTotal();
                                    }}
                                />
                            </td>
                            <td>
                                <input disabled
                                    id={`total-${item.product_id}`}
                                    className="border border-solid border-neutral-300 rounded"
                                    style={{ width: "100%" }}
                                    value={formatNumberWithCommas(parseNumericValue(item.quantity) * parseNumericValue(item.orderPrice ?? item.price))}
                                /></td>
                        </tr>
                    ))}
                </tbody>
                <tfoot className="font-bold">
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>Total Amount</td>
                        <td>{formatNumberWithCommas(overallTotal)}</td>
                    </tr>
                </tfoot>
            </table>
        </div>);
}

export default PurchaseOrderTable;
